import { useMemo } from 'react';
import { registerQuery, useQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
const FETCH_VIDEOS_QUERY = registerQuery({
  fieldName: 'videos',
  args: ['contentId'],
  fetcher: async ({
    contentId
  }) => {
    const response = await http.get('cosindex/api/v1/connections/children', {
      query: {
        childType: 'VIDEO_PLAYER',
        id: contentId
      }
    });
    return Array.isArray(response) ? response : [];
  }
});

/**
 * Hook to fetch videos used in a content item
 *
 * @param contentId - The ID of the content containing videos
 * @returns Object containing videos array, loading state, and error state
 */
export const useVideos = contentId => {
  const {
    data,
    loading,
    error
  } = useQuery(FETCH_VIDEOS_QUERY, {
    variables: {
      contentId
    },
    skip: !contentId
  });
  const videos = useMemo(() => {
    if (!data || !data.videos) {
      return [];
    }
    return data.videos.map(item => {
      var _model$meta;
      const model = item.model || {};
      const videoId = ((_model$meta = model.meta) === null || _model$meta === void 0 ? void 0 : _model$meta.original_external_uuid) || model.external_uuid || model.crm_object_id;
      return {
        value: videoId,
        text: item.label || 'Untitled Video',
        duration: model.duration || undefined
      };
    });
  }, [data]);
  return {
    videos,
    loading,
    error: (error === null || error === void 0 ? void 0 : error.message) || null
  };
};